var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('Compare'),_c('Alerts'),_c('UploadAlerts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }